class BestsellersSlider extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector('.js-bestsellers-slider');
    if (!this.slider || this.slider.swiper) return;

    const gap = parseInt(this.dataset.swiperGap, 10);
    const gapMobile = parseInt(this.dataset.swiperGapMobile, 10);

    new Swiper(this.slider, {
      slidesPerView: 'auto',
      spaceBetween: Number.isNaN(gapMobile) ? 12 : gapMobile,
      centeredSlides: true,
      centeredSlidesBounds: true,
      slidesOffsetBefore: this.gutter(),
      slidesOffsetAfter: this.gutter(),
      watchOverflow: true,
      navigation: {
        prevEl: Array.from(this.querySelectorAll('.js-bestsellers-prev, .js-bestsellers-overlay-prev')),
        nextEl: Array.from(this.querySelectorAll('.js-bestsellers-next, .js-bestsellers-overlay-next'))
      },
      breakpoints: {
        750: {
          spaceBetween: Number.isNaN(gap) ? 20 : gap,
          centeredSlides: false,
          centeredSlidesBounds: false
        }
      },
      on: {
        beforeInit: (swiper) => this.fixCenteredBoundsIndex(swiper),
        resize: (swiper) => this.syncEndOffset(swiper)
      }
    });
  }

  disconnectedCallback() {
    if (this.slider && this.slider.swiper) this.slider.swiper.destroy(true, true);
  }

  gutter() {
    if (!window.matchMedia('(min-width: 750px)').matches) return 0;
    return window.matchMedia('(min-width: 1200px)').matches ? 60 : 18;
  }

  fixCenteredBoundsIndex(swiper) {
    const updateSlides = swiper.updateSlides.bind(swiper);
    swiper.updateSlides = () => {
      updateSlides();
      if (swiper.params.centeredSlides && swiper.params.centeredSlidesBounds) {
        swiper.slidesGrid = swiper.snapGrid.slice();
      }
    };
  }

  syncEndOffset(swiper) {
    const slidesWidth =
      swiper.slides.reduce((width, slide) => width + slide.offsetWidth, 0) +
      Math.max(0, swiper.slides.length - 1) * (swiper.params.spaceBetween || 0);
    const before = this.gutter();
    const after = slidesWidth + before > swiper.width ? before : 0;
    if (swiper.params.slidesOffsetBefore !== before || swiper.params.slidesOffsetAfter !== after) {
      swiper.params.slidesOffsetBefore = before;
      swiper.params.slidesOffsetAfter = after;
      swiper.update();
    }
  }
}

if (!customElements.get('bestsellers-slider')) {
  customElements.define('bestsellers-slider', BestsellersSlider);
}
